import React, { Component } from 'react'
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActionsWrapped from "./pagination-wrapper";
import TableHead from "@material-ui/core/TableHead";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import * as XLSX from 'xlsx';
import moment from "moment";


const rowsPerPage = 12;

export default class PrintDataExcel extends Component {
    constructor(props) {
        super(props);
        this.excelPrints = this.props.prints.map(item => {
            const createDate = moment(item.timeStamp).format('MM/DD/YYYY');
            return { ...item, createDate }
        });
        this.state = {
            page: 0,
        }
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleExcelDownload = () => {
        const sheet = XLSX.utils.json_to_sheet(this.excelPrints.map(item => {
            delete item.timeStamp;
            return item;
        }));
        this.openDownloadDialog(this.sheet2blob(sheet, undefined), `prints.xlsx`);
    };

    openDownloadDialog = (url, saveName) => {
        if (typeof url == 'object' && url instanceof Blob) {
            url = URL.createObjectURL(url);
        }
        const aLink = document.createElement('a');
        aLink.href = url;
        aLink.download = saveName || '';
        let event;
        if (window.MouseEvent) {
            event = new MouseEvent('click');
        } else {
            event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        aLink.dispatchEvent(event);
    };

    sheet2blob = (sheet, sheetName) => {
        sheetName = sheetName || 'sheet1';
        const workbook = {
            SheetNames: [sheetName],
            Sheets: {}
        };
        workbook.Sheets[sheetName] = sheet;

        const wOpts = {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary'
        };
        const wbOut = XLSX.write(workbook, wOpts);

        function s2ab(workbookOut) {
            const buf = new ArrayBuffer(workbookOut.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i !== workbookOut.length; ++i) {
                view[i] = workbookOut.charCodeAt(i) & 0xFF;
            }
            return buf;
        }

        return new Blob([s2ab(wbOut)], {
            type: "application/octet-stream"
        });
    };


    render() {
        const { page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.excelPrints.length - page * rowsPerPage);
        return (
            <div style={{ width: 1000 }}>
                <AppBar position="static" color="default">
                    <Toolbar>
                        <Button onClick={() => {
                            this.handleExcelDownload()
                        }} style={{ marginLeft: "auto" }} variant='outlined'>download excel</Button>
                    </Toolbar>
                </AppBar>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>printer</TableCell>
                            <TableCell align="right">resin usage (ML)</TableCell>
                            <TableCell align="right">status</TableCell>
                            <TableCell align="right">resin color</TableCell>
                            <TableCell align="right">total print time (MIN)</TableCell>
                            <TableCell align="right">thickness</TableCell>
                            <TableCell align="right">finish date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.excelPrints.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
                            <TableRow key={item.timeStamp}>
                                <TableCell component="th" scope="row">
                                    {item.printer}
                                </TableCell>
                                <TableCell align="right">{item.resinUsage}</TableCell>
                                <TableCell align="right">{item.status}</TableCell>
                                <TableCell align="right">{item.resinColor}</TableCell>
                                <TableCell align="right">{item.totalPrintTime}</TableCell>
                                <TableCell align="right">{item.layerThickness}</TableCell>
                                <TableCell align="right">{item.createDate}</TableCell>
                            </TableRow>
                        ))}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 48 * emptyRows }}>
                                <TableCell colSpan={6}/>
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                colSpan={3}
                                count={this.excelPrints.length}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[10]}
                                page={page}
                                onChangePage={this.handleChangePage}
                                ActionsComponent={TablePaginationActionsWrapped}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-excel.js